export const AppFooter = () => {
  return null;
};
